<template>

    <div class="flex flex-col justify-center w-full xl:w-5/6 max-w-1920 mx-auto h-full">

        <div class="bg-white max-w-1220 w-full mx-auto rounded-6">

            <div class="max-w-720 mx-auto py-48">
                <div class="text-center">
                    <p class="font-semibold text-secondary uppercase tracking-wide text-heading-2">404 error</p>
                    <h1 class="text-big font-semibold text-primary tracking-tight">{{ $t('error.page_not_exist') }}</h1>
                    <p class="mt-20 text-body" v-html="$t('error.error_404_description')"></p>
                </div>
                <div class="mt-32">
                    <h2 class="font-semibold tracking-wide uppercase">{{ $t('general.popular_pages') }}</h2>

                    <ul class="mt-12" role="list">
                        <li v-for="item in listItems"
                            class="relative p-16 flex items-center space-x-14 hover:bg-primary-5 rounded-4 group">
                            <div class="shrink-0">
                                <span class="flex items-center justify-center p-12 rounded-32 bg-primary text-white">
                                    <svg-icon :type="item.icon" class="h-24 w-24"></svg-icon>
                                </span>
                            </div>
                            <div class="min-w-0 flex-1">
                                <h3>
                                    <span class="rounded-6 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-80">
                                        <a :href="item.link" class="focus:outline-none font-semibold">
                                            <span aria-hidden="true" class="absolute inset-0"></span>
                                            {{ item.title }}
                                        </a>
                                    </span>
                                </h3>
                                <p>{{ item.description }}</p>
                            </div>
                            <div class="shrink-0 self-center">
                                <svg-icon aria-hidden="true" class="w-24 h-24 text-primary-40" type="keyboard-arrow-right"></svg-icon>
                            </div>
                        </li>
                    </ul>

                    <div class="flex justify-center mt-32">
                        <router-link to="jobs">
                            <simple-button
                                look="primary"
                                icon="keyboard-arrow-left"
                                icon-position="left"
                            >
                                {{ $t('general.go_back_vacancies') }}
                            </simple-button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SvgIcon from '../components/ui/SvgIcon';
import SimpleButton from '../components/ui/SimpleButton';

export default {
    components: {SvgIcon, SimpleButton},
    computed: {
        listItems() {
            let lang = 'nl';

            if (Jobtoolz.user && Jobtoolz.user.attributes.language) {
                lang = Jobtoolz.user.attributes.language;
            }

            let blog_link = 'https://jobtoolz.com/blog/';

            if (lang === 'fr') {
                blog_link = 'https://jobtoolz.com/FR_FR/blog/';
            }
            if (lang === 'nl') {
                blog_link = 'https://jobtoolz.com/NL_NL/blog/';
            }

            return {
                'docs': {
                    'title': this.$t('error.404_links.docs.title'),
                    'description': this.$t('error.404_links.docs.description'),
                    'icon': 'extension',
                    'link': '/settings/integrations',
                },
                'api': {
                    'title': this.$t('error.404_links.api.title'),
                    'description': this.$t('error.404_links.api.description'),
                    'icon': 'api',
                    'link': 'https://docs.jobtoolz.com/',
                },
                'guides': {
                    'title': this.$t('error.404_links.guides.title'),
                    'description': this.$t('error.404_links.guides.description'),
                    'icon': 'book',
                    'link': `https://help.jobtoolz.com/${lang}`,
                },
                'blog': {
                    'title': this.$t('error.404_links.blog.title'),
                    'description': this.$t('error.404_links.blog.description'),
                    'icon': 'description',
                    'link': blog_link,
                },
            };
        },
    },
};
</script>